import React from 'react';
import ProposalList from './ProposalList';

interface CustomerProposalListProps {
  defaultStatusIds?: number[];
  type?: number;
}

const CustomerProposalList: React.FC<CustomerProposalListProps> = (props) => {
  return <ProposalList {...props} />;
};

export default CustomerProposalList;
